import React from 'react';
import { path, sortWith, descend, compose, omit } from 'ramda';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';
import CommonViewButton from 'routes/Documents/components/CommonViewButton';
import { getLatestFinishedCommitData } from 'lib/documentHandling';

import { formatHeaderDate, editTimeLeft, dateValue } from 'lib/dateDisplay';

import calculate from '../calculateFSS';
import { isPartialDate, partialDateToValue } from 'neuro-utils';

export const sorter = sortWith([descend(compose(dateValue, path(['createDate'])))]);

const msg = id => ({ id });

const renderEntryHeader = (doc, fm) =>
  `${doc?.content?.date && isPartialDate(doc.content.date) ? formatHeaderDate(partialDateToValue(doc.content.date)) : formatHeaderDate(doc.createDate)}`;
const renderHeader = m => <p children={m} />;

const historyMapper =
  (name, edit, view) =>
  (d, { formatMessage }) => (
    <HistoryEntry key={d.documentId}>
      <HistoryEntryHeader title={renderEntryHeader(d, formatMessage)} active={editTimeLeft(d.createDate)}>
        {editTimeLeft(d?.content?.date ? partialDateToValue(d.content.date) : d.createDate) && (
          <CommonHistoryEntryControls
            time={d?.content?.date ? partialDateToValue(d.content.date) : d.createDate}
            action={() => edit(name, d.documentId, getLatestFinishedCommitData(d))}
          />
        )}
        {(window.__ROLE__ === 'DOCTOR' ||
          !editTimeLeft(d?.content?.date ? partialDateToValue(d.content.date) : d.createDate)) && (
          <CommonViewButton onView={e => view('fss', d.documentId)} />
        )}
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('fss.labels.filled')))}>
          <p>{d.filled + ' / 9'}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('fss.labels.score')))}>
          <p>{calculate(omit(['date'], d.content))}</p>
        </HistoryEntryColumn>
      </HistoryEntryColumns>
    </HistoryEntry>
  );

export default historyMapper;
